/**
 * Whether this page is on its way out — reloaded, closed, navigated away (2026-10-09).
 *
 * A request still in flight then ends in the browser's abort, which reads exactly like a network
 * failure. Logged as one, it put a visitor down for three `plan_failed (error)` whose plans the
 * server finished every time: each was cut off by the page reloading. A failure seen while leaving
 * is the page's, not the request's.
 */
let leaving = false;

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    leaving = true;
  });
  window.addEventListener('pagehide', () => {
    leaving = true;
  });
  // Restored from the back-forward cache: here again, and nothing is leaving.
  window.addEventListener('pageshow', (e: PageTransitionEvent) => {
    if (e.persisted) leaving = false;
  });
}

export function pageIsLeaving(): boolean {
  return leaving;
}

/** Tests only: a fresh page. */
export function resetLeaving(): void {
  leaving = false;
}
